import { useState } from "react";
import AbstractFilter from "../../../../shared/@types/AbstractFilter";
import { ConsultarEventosConstants } from "../utils/ConsultarEventosConstants";
import { ConsultarEventosFiltrosStorage } from "../utils/filterStorage";

export default class ConsultarEventosFilter extends AbstractFilter {
  public busca: any;
  public setBusca: any;
  public numeroAudiencia: any;
  public setNumeroAudiencia: any;
  public codigoAno: any;
  public setCodigoAno: any;
  public codigoSituacao: any;
  public setCodigoSituacao: any;
  public codigoTipoEvento: any;
  public setCodigoTipoEvento: any;
  public ordering: any;
  public setOrdering: any;
  public recebimentoDeContribuicaoInicial: any;
  public setRecebimentoDeContribuicaoInicial: any;
  public recebimentoDeContribuicaoFinal: any;
  public setRecebimentoDeContribuicaoFinal: any;
  public stAgendaRegulatoria: any;
  public setStAgendaRegulatoria: any;

  constructor() {
    super();
    [this.busca, this.setBusca] = useState("");
    [this.numeroAudiencia, this.setNumeroAudiencia] = useState("");
    [this.codigoAno, this.setCodigoAno] = useState("");
    [this.codigoSituacao, this.setCodigoSituacao] = useState("");
    [this.codigoTipoEvento, this.setCodigoTipoEvento] = useState("");
    [this.ordering, this.setOrdering] = useState("ano");
    [this.recebimentoDeContribuicaoInicial, this.setRecebimentoDeContribuicaoInicial] =
      useState("");
    [this.recebimentoDeContribuicaoFinal, this.setRecebimentoDeContribuicaoFinal] =
      useState("");
    [this.stAgendaRegulatoria, this.setStAgendaRegulatoria] = useState(
      ConsultarEventosConstants.AGENDA_AMBOS
    );
  }

  setFromObject(json: ConsultarEventosFiltrosStorage) {
    this.setBusca(json.busca ?? "");
    this.setNumeroAudiencia(json.numeroAudiencia ?? "");
    this.setCodigoAno(json.codigoAno ?? "");
    this.setCodigoSituacao(json.codigoSituacao ?? "");
    this.setCodigoTipoEvento(json.codigoTipoEvento ?? "");
    this.setOrdering(json.ordering || "ano");
    this.setRecebimentoDeContribuicaoInicial(
      json.recebimentoDeContribuicaoInicial ?? ""
    );
    this.setRecebimentoDeContribuicaoFinal(
      json.recebimentoDeContribuicaoFinal ?? ""
    );
    this.setStAgendaRegulatoria(
      json.stAgendaRegulatoria || ConsultarEventosConstants.AGENDA_AMBOS
    );
  }

  limpar() {
    this.setBusca("");
    this.setNumeroAudiencia("");
    this.setCodigoAno("");
    this.setCodigoSituacao("");
    this.setCodigoTipoEvento("");
    this.setOrdering("ano");
    this.setRecebimentoDeContribuicaoInicial("");
    this.setRecebimentoDeContribuicaoFinal("");
    this.setStAgendaRegulatoria(ConsultarEventosConstants.AGENDA_AMBOS);
  }
}
